import React from "react";
import {
  Identifiable,
  list,
  ProjectElementType,
  List as L,
} from "@planzone/dto";
import { useTranslation } from "react-i18next";
import { useListsRetrieval } from "@planzone/view-models";

import { ListSelect } from "@common/listSelect";
import { Props } from "./types";
import styles from "./styles.scss";

function List({
  project,
  projectElementId,
  projectElementType,
  nextParentList,
  setNextParentList,
}: Props) {
  const { t } = useTranslation();
  const filter = { limit: 999999999999, start: 0 };
  const {
    lists,
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    retrieveLists,
  } = useListsRetrieval(project, filter);

  React.useEffect(() => {
    !!project.uuid &&
      !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveLists({ project, filter });
  }, [project.uuid]);

  React.useEffect(() => {
    isRequestSuccess && setNextParentList(lists);
  }, [isRequestSuccess]);

  return (
    <div className={styles.list}>
      <h2>{t("moveElement.list")}</h2>
      <ListSelect
        lists={[lists]}
        filteredLists={
          projectElementType === ProjectElementType.LIST
            ? [{ ...list, uuid: projectElementId }]
            : []
        }
        selectedList={nextParentList || lists}
        selectList={setNextParentList}
      />
    </div>
  );
}

export { List };
